{
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Déconnexion",
    "account": "Compte",
    "profile": "Profil",
    "hello": "Bonjour",
    "home": "Accueil",
    "loading": "Chargement...",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "close": "Fermer",
    "save": "Enregistrer",
    "records": "Enregistrements",
    "add": "Ajouter",
    "read": "Lire",
    "write": "Enregistrer",
    "edit": "Modifier",
    "new": "Nouveau",
    "delete": "Supprimer",
    "actions": "Actions",
    "active": "Actif",
    "inactive": "Inactif",
    "search": "Rechercher",
    "yes": "Oui",
    "no": "Non",
    "years": "Années",
    "months": "Mois",
    "favorites": "Favoris",
    "reports": "Rapports",
    "recordsPerPage": "Enregistrements par page",
    "changePassword": "Modifier le mot de passe",
    "longDateFormat": "{years} année(s) et {months} mois",
    "importData": "Importer des données",
    "upload": "Télécharger",
    "downloadTemplate": "Télécharger le modèle",
    "selectOption": "Sélectionnez une option",
    "id": "ID",
    "translations": "Traductions",
    "or": "ou",
    "review": "Examiner",
    "approve": "Approuver",
    "reject": "Rejeter",
    "reviewComments": "Commentaires d'Examen",
    "reviewOnBehalfOf": "Examiner au nom de",
    "reviewed": "Examiné",
    "reviewedBy": "Examiné Par ",
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "skipped": "Ignoré",
    "warning": "Avertissement",
    "leave": "Quitter",
    "export": "Exporter",
    "import": "Importer",
    "next": "Suivant",
    "previous": "Précédent",
    "done": "Terminé",
    "permissionActions": {
      "read": "Lire",
      "write": "Écrire",
      "delete": "Supprimer",
      "execute": "Exécuter"
    },
    "messages": {
      "formUnsavedChanges": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer ?",
      "serverError": "Erreur du serveur. Veuillez réessayer plus tard ou contacter l'administrateur système.",
      "networkError": "Impossible de se connecter au serveur. Vérifiez votre connexion internet ou contactez l'administrateur système.",
      "forbidden": "Vous n'avez pas l'autorisation d'accéder à cette ressource. Contactez l'administrateur système si vous pensez qu'il s'agit d'une erreur.",
      "fileUploadError": "Erreur lors du téléchargement du fichier. Vérifiez le format et la taille du fichier et réessayez.",
      "fileUploadSuccessEmail": "Fichier téléchargé avec succès. Un e-mail avec le résultat de l'importation sera envoyé prochainement.",
      "failedLoadPermissions": "Échec du chargement des autorisations utilisateur. Veuillez actualiser la page ou contacter l'administrateur système.",
      "downloadingFile": "Téléchargement du fichier...",
      "fileDownloadError": "Erreur lors du téléchargement du fichier. Veuillez réessayer ou contacter l'administrateur système.",
      "fileImportedSuccessfully": "Fichier importé avec succès."
    },
    "warnings": {
      "maxDisplayedRecords": "Le nombre maximum d'enregistrements affichés est de 500. Pour voir plus d'enregistrements, utilisez la recherche."
    },
    "validation": {
      "required": "Ce champ est obligatoire.",
      "email": "Veuillez saisir une adresse e-mail valide.",
      "minValue": "La valeur doit être d'au moins {min}.",
      "maxValue": "La valeur ne peut pas être supérieure à {max}.",
      "onlyIntegers": "La valeur doit être un nombre entier.",
      "invalidDate": "La date saisie est invalide."
    },
    "baseAuditableEntity": {
      "createdBy": "Créé par",
      "createdDate": "Date de création",
      "modifiedBy": "Modifié par",
      "modifiedDate": "Date de modification"
    }
  },
  "reportViewer": {
    "noFilterMessage": "Aucun filtre pour ce rapport",
    "noAccessReport": "Vous n'avez pas accès à ce rapport. Veuillez contacter l'administrateur système si vous pensez qu'il s'agit d'une erreur.",
    "pdfSizeErrorMessage": "La taille du PDF est trop importante et ne peut pas être affichée.",
    "pdfMaxSizeDownloaded": "Le rapport est trop volumineux pour être affiché. Vérifiez votre dossier de téléchargement.",
    "failedLoadReports": "Échec du chargement des rapports. Les autres fonctionnalités fonctionneront normalement. Veuillez actualiser la page ou contacter l'administrateur système si le problème persiste.",
    "run": "Exécuter",
    "download": "Télécharger",
    "viewFilter": {
      "button": "Voir les Filtres...",
      "title": "Paramètres",
      "name": "Nom",
      "value": "Valeur"
    },
    "fullScreen": "Plein Écran...",
    "smallScreen": "Petit Écran...",
    "tabButton": {
      "fullScreen": "Masquer la section des paramètres",
      "smallScreen": "Afficher la section des paramètres",
      "about": "À propos",
      "downloadExcel": "Télécharger le fichier de feuille de calcul",
      "clear": "Fermer Tous les Onglets"
    },
    "modalAbout": {
      "title": "À propos",
      "description": "Description",
      "version": "Version",
      "reference": "Référence",
      "lastChange": "Dernier Changement",
      "dataSource": "Source de Données"
    }
  },
  "file": {
    "description": "Description",
    "files": "Fichiers",
    "editDescription": "Modifier la Description",
    "delete": "Supprimer le Fichier",
    "download": "Télécharger le Fichier",
    "pendingUpload": "Téléchargement en attente. Le fichier ne sera enregistré qu'après avoir cliqué sur 'Enregistrer'.",
    "noFiles": "Aucun fichier ajouté."
  },
  "404": {
    "title": "Cette page n'a pas été trouvée.",
    "text": "La page demandée n'a pas pu être trouvée.",
    "back_button": "Retour au tableau de bord"
  },
  "403": {
    "title": "Vous n'avez pas l'autorisation d'accéder à cette page.",
    "text": "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur.",
    "back_button": "Retour au tableau de bord"
  },
  "401": {
    "title": "Vous n'êtes pas autorisé à accéder à cette page.",
    "text": "Si vous pensez que ce n'est pas correct, contactez l'administrateur",
    "back_button": "Retour au tableau de bord"
  },
  "dashboard": {
    "menuTitle": "Tableau de Bord",
    "title": "Tableau de Bord",
    "addWidget": "Ajouter un Widget",
    "editLayout": "Modifier la Mise en Page",
    "saveLayout": "Enregistrer la Mise en Page",
    "importLayout": "Importer la Mise en Page",
    "exportLayout": "Exporter la Mise en Page",
    "category": "Catégorie",
    "widget": "Widget",
    "widgetTitle": "Titre",
    "widgetParameters": "Paramètres",
    "widgetInformation": "Informations du Widget",
    "noParameters": "Ce widget n'a aucun paramètre.",
    "delete": "Supprimer le Widget",
    "viewLink": "voir",
    "messages": {
      "saveSuccess": "Mise en page enregistrée avec succès.",
      "importSuccess": "Mise en page importée avec succès.",
      "exportSuccess": "Mise en page exportée avec succès.",
      "importFailed": "Échec de l'importation de la mise en page.",
      "widgetNotFound": "Widget non trouvé",
      "failedToLoad": "Échec du chargement",
      "noDataAvailable": "Aucune donnée disponible"
    },
    "tutorial": {
      "mainMessage": "Bienvenue sur votre tableau de bord ! Utilisez les boutons ci-dessus pour le personnaliser.",
      "callToAction": "Montrez-moi comment !",
      "instructions": {
        "add": {
          "title": "Bouton Ajouter un Widget",
          "description": "Ici, vous pourrez trouver des widgets par catégorie. Certains d'entre eux peuvent avoir des paramètres pour vous permettre un tableau de bord entièrement personnalisable. N'oubliez pas d'appuyer sur ENREGISTRER après avoir ajouté tous vos widgets."
        },
        "edit": {
          "title": "Modifier la Mise en Page du Widget",
          "description": "Ici, vous pourrez modifier votre tableau de bord : Ajouter ou supprimer des widgets, les déplacer et les redimensionner. N'oubliez pas d'enregistrer après modification."
        },
        "import": {
          "title": "Importer la Mise en Page",
          "description": "Avec un fichier de sauvegarde, vous pouvez l'importer ici. Note : Votre tableau de bord sera écrasé."
        },
        "export": {
          "title": "Exporter la Mise en Page",
          "description": "Une fois votre tableau de bord terminé, vous pouvez l'exporter pour avoir une sauvegarde OU l'envoyer à un autre utilisateur pour copier votre tableau de bord."
        }
      }
    }
  },
  "settings": {
    "title": "Paramètres",
    "theme": {
      "name": "Thème",
      "dark": "Sombre",
      "light": "Clair"
    }
  },
  "userInfo": {
    "title": "Informations Utilisateur",
    "permissions": "Autorisations",
    "userName": "Nom d'utilisateur",
    "fullName": "Nom Complet",
    "email": "E-mail",
    "employeeId": "ID Employé",
    "action": "Action",
    "permissionCode": "Code d'Autorisation"
  },
  "impersonate": {
    "title": "Usurper l'Identité Utilisateur",
    "userName": "Connexion",
    "start": "Démarrer l'Usurpation d'Identité",
    "messages": {
      "impersonationStarted": "Session d'usurpation d'identité démarrée. Pour retourner à votre compte, veuillez vous déconnecter et vous reconnecter.",
      "userNotFound": "Utilisateur non trouvé. Veuillez vérifier le nom d'utilisateur et réessayer."
    }
  },
  "about": {
    "menuName": "À propos",
    "title": "À propos"
  },
  "releaseNotes": {
    "menuName": "Notes de Version",
    "title": "Notes de Version",
    "name": "Nom",
    "version": "Version",
    "description": "Description",
    "appType": "Type d'Application",
    "releaseDate": "Date de Publication",
    "messages": {
      "notFound": "Note de version non trouvée.",
      "saveError": "Erreur lors de l'enregistrement de la note de version. Veuillez réessayer plus tard."
    }
  },
  "admin": {
    "menuTitle": "Administration",
    "menuHierarchy": {
      "menuName": "Hiérarchie du Menu",
      "pageTitle": "Hiérarchie du Menu",
      "displayName": "Nom d'Affichage",
      "routeParam": "Paramètre du Menu",
      "securityResources": "Ressources de Sécurité",
      "children": "Sous-Menus",
      "isActive": "Est Actif",
      "icon": "Icône",
      "displayOrder": "Ordre d'Affichage",
      "edit": "Modifier l'Élément du Menu",
      "messages": {
        "success": "Élément du menu enregistré avec succès."
      }
    },
    "notificationTemplate": {
      "menuName": "Modèle de Notification",
      "pageTitle": "Modèle de Notification",
      "name": "Nom",
      "parent": "Modèle Parent",
      "parentInfo": "Seuls les modèles commençant par masterTemplate peuvent être utilisés comme modèle parent.",
      "pushNotificationEnabled": "Notification Push Activée",
      "pushRoute": "Route de Notification Push",
      "sqlQuery": "Requête SQL",
      "sqlQueryDateFormatInfo": "Les colonnes de date doivent être formatées au format MM/dd/yyyy.",
      "generalSection": "Informations Générales",
      "emailSection": "Notification par E-mail",
      "emailSubject": "Sujet de l'E-mail",
      "emailBody": "Corps de l'E-mail (HTML)",
      "pushSection": "Notification Push",
      "pushSubject": "Sujet Push",
      "pushBody": "Corps Push",
      "overrideNotificationTemplate": "Remplacer le Modèle de Notification",
      "add": "Ajouter un Modèle",
      "edit": "Modifier le Modèle",
      "delete": {
        "title": "Supprimer le Modèle",
        "text": "Êtes-vous sûr de vouloir supprimer le modèle \"{name}\" ?"
      },
      "messages": {
        "created": "Modèle de notification créé avec succès.",
        "updated": "Modèle de notification mis à jour avec succès.",
        "deleted": "Modèle de notification supprimé avec succès.",
        "alreadyExists": "Un modèle de notification avec ce nom existe déjà.",
        "fileRequired": "Le fichier est obligatoire.",
        "importError": "Une erreur s'est produite lors de l'importation du modèle de notification."
      }
    },
    "department": {
      "menuName": "Département",
      "pageTitle": "Département",
      "name": "Nom",
      "isActive": "Est Actif",
      "add": "Ajouter un Département",
      "edit": "Modifier le Département",
      "delete": {
        "title": "Supprimer le Département",
        "text": "Êtes-vous sûr de vouloir supprimer ce département ?"
      },
      "messages": {
        "created": "Département créé avec succès.",
        "updated": "Département mis à jour avec succès.",
        "deleted": "Département supprimé avec succès."
      }
    },
    "businessArea": {
      "menuName": "Domaine d'Affaires",
      "pageTitle": "Domaine d'Affaires",
      "id": "Id",
      "externalId": "Id Externe",
      "description": "Description",
      "calendarId": "Calendrier",
      "isActive": "Est Actif",
      "edit": "Modifier le Domaine d'Affaires",
      "messages": {
        "created": "Domaine d'Affaires créé avec succès.",
        "updated": "Domaine d'Affaires mis à jour avec succès.",
        "deleted": "Domaine d'Affaires supprimé avec succès."
      }
    },

    "configuration": {
      "menuName": "Configuration",
      "pageTitle": "Configuration",
      "key": "Clé",
      "value": "Valeur",
      "editorType": "Type",
      "add": "Ajouter une Configuration",
      "edit": "Modifier la Configuration",
      "delete": {
        "title": "Supprimer la Configuration",
        "text": "Êtes-vous sûr de vouloir supprimer cette configuration ?"
      },
      "messages": {
        "created": "Configuration créée avec succès.",
        "updated": "Configuration mise à jour avec succès.",
        "deleted": "Configuration supprimée avec succès."
      },
      "types": {
        "text": "Texte",
        "string": "Chaîne",
        "number": "Nombre",
        "int": "Entier",
        "boolean": "Booléen"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nom",
      "description": "Description",
      "securityResources": "Ressources de Sécurité",
      "link": "Lien",
      "query": "Requête SQL",
      "queryRequired": "La requête SQL est obligatoire.",
      "sqlQueryDateFormatInfo": "Les colonnes de date doivent être formatées au format MM/dd/yyyy.",
      "minHeight": "Hauteur Minimale",
      "minWidth": "Largeur Minimale",
      "type": "Type",
      "category": "Catégorie",
      "add": "Ajouter un Widget",
      "edit": "Modifier le Widget",
      "delete": {
        "title": "Supprimer le Widget",
        "text": "Êtes-vous sûr de vouloir supprimer ce widget ?"
      },
      "examples": {
        "viewSQLExamples": "Voir les exemples SQL",
        "general": "Général",
        "generalDescription": "Par défaut, le système fournit les paramètres suivants, qui peuvent être référencés directement dans toute requête SQL de widget.",
        "loggedUserNameDescription": "Nom d'utilisateur de connexion de l'utilisateur actuellement connecté (par exemple : {email}).",
        "loggedUserEmployeeIdDescription": "Identifiant d'employé de l'utilisateur actuellement connecté.",
        "loggedUserLanguageDescription": "Code de langue de l'utilisateur actuellement connecté (par exemple : en-US, pt-BR).",
        "listDescription": "Chaque ligne représente un élément de liste.",
        "numberDescription": "Renvoie une seule valeur numérique.",
        "donutDescription": "Les étiquettes et les valeurs doivent être alignées par position.",
        "lineDescription": "Chaque ligne représente une série de lignes."
      },
      "messages": {
        "created": "Widget créé avec succès.",
        "updated": "Widget mis à jour avec succès.",
        "deleted": "Widget supprimé avec succès.",
        "fileRequired": "Le fichier est obligatoire.",
        "importError": "Une erreur s'est produite lors de l'importation du widget.",
        "queryVariablesMissing": "Les variables suivantes sont manquantes dans la requête du widget : \"{variables}\". Veuillez les ajouter à la requête pour assurer un fonctionnement correct."
      }
    },
    "widgetCategory": {
      "menuName": "Catégorie de Widget",
      "pageTitle": "Catégorie de Widget",
      "name": "Nom",
      "description": "Description",
      "type": "Type",
      "add": "Ajouter une Catégorie de Widget",
      "edit": "Modifier la Catégorie de Widget",
      "delete": {
        "title": "Supprimer la Catégorie de Widget",
        "text": "Êtes-vous sûr de vouloir supprimer cette catégorie de widget ?"
      },
      "messages": {
        "created": "Catégorie de Widget créée avec succès.",
        "updated": "Catégorie de Widget mise à jour avec succès.",
        "deleted": "Catégorie de Widget supprimée avec succès."
      }
    },
    "widgetType": {
      "menuName": "Type de Widget",
      "pageTitle": "Type de Widget",
      "name": "Nom",
      "types": {
        "number": "Nombre",
        "list": "Liste",
        "donut": "Graphique en anneau",
        "line": "Ligne"
      }
    },
    "widgetParameter": {
      "menuName": "Paramètre de Widget",
      "menuTitle": "Paramètre de Widget",
      "title": "Paramètre de Widget",
      "name": "Nom",
      "nameInfo": "Nom utilisé pour identifier le paramètre dans la requête SQL du widget. N'utilisez pas d'espaces ou de caractères spéciaux.",
      "nameUniqueError": "Un Paramètre de Widget avec ce nom existe déjà.",
      "description": "Description",
      "isRequired": "Est Obligatoire ?",
      "isMultiple": "Est Multiple ?",
      "status": "Statut",
      "edit": "Modifier le Paramètre de Widget",
      "add": "Ajouter un Paramètre de Widget",
      "type": "Type",
      "data": "Requête SQL",
      "dataInfo": "La requête SQL doit retourner deux colonnes nommées 'Value' et 'Text'.",
      "listOfValues": "Liste de Valeurs",
      "addValue": "Ajouter une Valeur",
      "value": "Valeur",
      "label": "Étiquette",
      "delete": {
        "title": "Supprimer le Paramètre de Widget",
        "text": "Êtes-vous sûr de vouloir supprimer {name} ?"
      },
      "types": {
        "text": "Texte",
        "number": "Nombre",
        "date": "Date",
        "boolean": "Booléen",
        "select": "Liste",
        "sql": "Liste de Requête"
      },
      "messages": {
        "notFound": "Paramètre de Widget non trouvé.",
        "saveSuccess": "Paramètre de Widget enregistré avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement du Paramètre de Widget.",
        "deleteSuccess": "Paramètre de Widget supprimé avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression du Paramètre de Widget.",
        "isInUse": "Impossible de supprimer le Paramètre de Widget car il est en cours d'utilisation."
      }
    },
    "people": {
      "employeeId": "ID Employé",
      "name": "Nom",
      "position": "Poste",
      "person": "Personne",
      "personTypes": {
        "unknown": "Inconnu",
        "salariedEmployee": "Employé Salarié",
        "contractor": "Contractuel",
        "vendor": "Fournisseur",
        "hourlyEmployee": "Employé Horaire",
        "external": "Externe",
        "duHourlyInactive": "DU Horaire Inactif",
        "duSalariedInactive": "DU Salarié Inactif",
        "duTruckDriverIn": "DU Chauffeur de Camion En",
        "executive": "Cadre",
        "union": "Syndiqué",
        "nonUnion": "Non Syndiqué",
        "unionPossible": "Syndicalisation Possible",
        "salariedNonExempt": "Salarié Non Exempté",
        "hourly": "Horaire",
        "duPaidLeave": "DU Congé Payé",
        "truckDriver": "Chauffeur de Camion",
        "duUnpaidLeave": "DU Congé Non Payé",
        "workRelease": "Libération de Travail",
        "externalAccessLevelOne": "Accès Externe Niveau Un",
        "externalAccessLevelTwo": "Accès Externe Niveau Deux",
        "externalAccessLevelThree": "Accès Externe Niveau Trois",
        "externalAccessLevelFour": "Accès Externe Niveau Quatre",
        "externalAccessLevelFive": "Accès Externe Niveau Cinq",
        "globalEmployee": "Employé Global"
      }
    }
  },
  "vuestic": {
    "search": "Rechercher",
    "noOptions": "Éléments non trouvés",
    "ok": "OK",
    "cancel": "Annuler",
    "uploadFile": "Sélectionner un fichier",
    "undo": "Annuler",
    "dropzone": "Déposez les fichiers ici pour les télécharger",
    "fileDeleted": "Fichier supprimé",
    "closeAlert": "fermer l'alerte",
    "backToTop": "retour en haut",
    "toggleDropdown": "basculer le menu déroulant",
    "carousel": "carrousel",
    "goPreviousSlide": "aller à la diapositive précédente",
    "goNextSlide": "aller à la diapositive suivante",
    "goSlide": "aller à la diapositive {index}",
    "slideOf": "diapositive {index} sur {length}",
    "close": "fermer",
    "openColorPicker": "ouvrir le sélecteur de couleur",
    "colorSelection": "sélection de couleur",
    "colorName": "couleur {color}",
    "decreaseCounter": "diminuer le compteur",
    "increaseCounter": "augmenter le compteur",
    "selectAllRows": "sélectionner toutes les lignes",
    "sortColumnBy": "trier la colonne par {name}",
    "selectRowByIndex": "sélectionner la ligne {index}",
    "resetDate": "réinitialiser la date",
    "nextPeriod": "période suivante",
    "switchView": "changer de vue",
    "previousPeriod": "période précédente",
    "removeFile": "supprimer le fichier",
    "reset": "réinitialiser",
    "pagination": "pagination",
    "goToTheFirstPage": "aller à la première page",
    "goToPreviousPage": "aller à la page précédente",
    "goToSpecificPage": "aller à la page {page}",
    "goToSpecificPageInput": "saisir le numéro de page",
    "goNextPage": "aller à la page suivante",
    "goLastPage": "aller à la dernière page",
    "currentRating": "note actuelle {value} sur {max}",
    "voteRating": "voter note {value} sur {max}",
    "optionsFilter": "filtre d'options",
    "splitPanels": "diviser les panneaux",
    "movePaginationLeft": "déplacer la pagination à gauche",
    "movePaginationRight": "déplacer la pagination à droite",
    "resetTime": "réinitialiser l'heure",
    "closeToast": "fermer la notification",
    "selectedOption": "Option sélectionnée",
    "noSelectedOption": "Aucune option sélectionnée",
    "breadcrumbs": "fil d'ariane",
    "counterValue": "valeur du compteur",
    "selectedDate": "date sélectionnée",
    "selectedTime": "heure sélectionnée",
    "progressState": "état du progrès",
    "color": "couleur",
    "next": "Suivant",
    "back": "Retour",
    "finish": "Terminer",
    "step": "étape",
    "progress": "progrès",
    "loading": "Chargement",
    "sliderValue": "La valeur actuelle du curseur est {value}",
    "switch": "Basculer",
    "inputField": "Champ de saisie",
    "fileTypeIncorrect": "Type de fichier incorrect",
    "select": "Sélectionner une option"
  }
}
